// import { BUTTON_TYPE } from '@bepure/tarkin';
import React, { useState, useEffect } from 'react';
// import AddToCartBtn, { CartProduct } from './AddToCartBtn';
// import BuyNowBtn from './BuyNowBtn';


interface Props {
    children?: JSX.Element | JSX.Element[]
}

const StickyPurchaseButtons = (props: Props) => {
    const [previousScrollPosition, setPreviousScrollPos] = useState(0);
    const [currentScrollPosition, setCurrentScrollPos] = useState(0);
    const scrollUp = previousScrollPosition < currentScrollPosition && currentScrollPosition > (80 + 80);
    useEffect(() =>{
        window.addEventListener('scroll', handleScroll)
    })


    const handleScroll = (event: any) => {
        const scrollTop = window.pageYOffset;
        const prevPos = currentScrollPosition;
        setCurrentScrollPos(scrollTop);
        setPreviousScrollPos(prevPos);
    }

    return(
        <div>
            <div className="sticky-buffer"></div>
            <div className={`sticky-purchase-buttons-section ${scrollUp ? 'sticky-purchase-buttons-section--scroll_up'
                : '' }`}>
                <div className="sticky-purchase-buttons-section__container">
                    {props.children}
                </div>

            </div>
        </div>
    )
}

export default StickyPurchaseButtons;
